import api from "../api";

const getCurrentInvoiceRange = async ({ storeCode }) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/management/stores/${encodeURIComponent(
    storeCode
  )}/invoice-ranges/current`;
  const response = await api.get(endpoint);
  return response.data;
};

export default getCurrentInvoiceRange;
